import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Container, Divider, Typography } from '@material-ui/core';

interface LocationState {
  htmlContent: string;
  title: string;
  historyPath: string;
}

const HTMLContentPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation<LocationState>();
  const { htmlContent, title, historyPath } = location.state || { htmlContent: '', title: '', historyPath: '/panel/dashboard' };

  if (!slug || !htmlContent) {
    return (
      <Container>
        <Typography style={{ cursor: 'default' }}>
          <Link to={historyPath} style={{ textDecoration: 'none', color: '#556275' }}>
            Conteúdo
          </Link> / {title}
        </Typography>
        <br />
        <Divider />
        <br />
        <Typography variant="h6">Dados não encontrados.</Typography>
      </Container>
    );
  }

  return (
    <Container>
      <Typography style={{ cursor: 'default' }}>
        <Link to={historyPath} style={{ textDecoration: 'none', color: '#556275' }}>
          Conteúdo
        </Link> / {title}
      </Typography>
      <br />
      <Divider />
      <br />
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Container>
  );
};


export default HTMLContentPage;
